import { all } from 'redux-saga/effects';
import { takeStreamFetch } from '@wix/da-shared-react/pkg/Stream/helpers';
import { fetchNextGallerySubfolders } from '../../actions/studio/folders';
import { handleFetchNextGallerySubfolders } from './handleFetchNextGallerySubfolders';
import { fetchNextSellerDiscountsEnded } from '../../actions/studio/discounts';
import { handleFetchNextSellerDiscountsEnded } from './handleFetchNextSellerDiscounts';

export default function* saga() {
  yield all([
    takeStreamFetch(
      fetchNextGallerySubfolders,
      handleFetchNextGallerySubfolders
    ),
    takeStreamFetch(
      fetchNextSellerDiscountsEnded,
      handleFetchNextSellerDiscountsEnded
    ),
  ]);
}
